import { useL10n } from '@uplift/hooks';
import { DateOfBirthInput } from '@uplift/ui-v2';
import { Form } from 'formik';

export const DobForm = () => {
  const l10n = useL10n();

  return (
    <Form>
      <DateOfBirthInput
        name="dob"
        label={l10n.accountSettings.dateOfBirth}
        helperText={l10n.accountSettings.dateOfBirthTip}
        id="dob"
      />
    </Form>
  );
};
